import React from "react";
import "./ServiceCard.css";

const ServiceCard = ({ icon, title, desc, features, idealFor }) => {
  return (
    <div className="service-card">
      {/* Centered Icon */}
      <div className="service-icon">{icon}</div>

      {/* Centered Title & Description */}
      <h3 className="service-title">{title}</h3>
      <p className="desc">{desc}</p>

      {/* Left-aligned Key Features */}
      {features && (
        <div className="features-section">
          <h4>Key Features:</h4>
          {/* <ul className="features-list">
            {features.map((f, idx) => (
              <li key={idx}>{f}</li>
            ))}
          </ul> */}
          <div className="features-list">
            {features.map((f, idx) => (
              <li key={idx}>
                <span className="feature-dot">◆</span>
                {f}
              </li>
            ))}
          </div>
        </div>
      )}

      {/* Ideal For box (keep left aligned) */}
      {idealFor && (
        <p className="ideal-for">
          <strong>Ideal For:</strong> {idealFor}
        </p>
      )}
    </div>
  );
};

export default ServiceCard;
